import React from 'react'
import styled from 'styled-components'
import logo from 'images/common/logo.svg'
import CrowdWorksCompanyName from '../CrowdWorksCompanyName'
import { SimpleFooterProps } from './types'

const Footer = styled.footer<SimpleFooterProps>`
  position: relative;
  width: 100%;
  bottom: 0;
  background-color: ${props => props.theme.members.colors.white};
  color: ${props => props.theme.members.colors.gray};
  font-size: 0.75rem;
  line-height: 1.625;
  z-index: 101;

  @media ${props => props.theme.media.md} {
    position: ${props => props.stickyFooter ? 'sticky' : 'relative'};
  }
`

const FooterWrapper = styled.div`
  margin: 0 auto;
  padding: 0 1.25rem 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 1.6875rem;

  @media ${props => props.theme.media.md} {
    width: min(1120px, 100%);
    justify-content: space-between;
    padding: 0;
  }
`

const FooterContent = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  row-gap: .5rem;
  column-gap: 1.6875rem;

  @media ${props => props.theme.media.md} {
    justify-content: flex-start;
    padding: 0 1rem;
  }
`

const Logo = styled.a`
  img {
    width: 146px;
  }

  @media ${props => props.theme.media.xl} {
    img {
      width: 178px;
    }
  }
`

const LinkToTop = styled.a`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  box-shadow: 1px 1px 4px 0 #0000004D;
  display: flex;
  justify-content: center;
  align-items: center;

  @media screen and ${props => props.theme.media.md} {
    width: 60px;
    height: 60px;
    border-radius: unset;
    box-shadow: none;
  }
`

const UpArrow = styled.div`
  border-top: 2px solid #06AA6A;
  border-right: 2px solid #06AA6A;
  width: .8rem;
  height: .8rem;
  transform: translateY(25%) rotate(-45deg);
`

export const StyledSimpleFooter: React.FC = (props: SimpleFooterProps) => {
  return (
    <Footer stickyFooter={props.stickyFooter}>
      <FooterWrapper>
        <FooterContent>
          <Logo href="/">
            <img src={logo} alt="クラウドワークス テック" />
          </Logo>
          <div>copyright (c) CrowdWorks Inc. all rights reserved.<br/>運営会社：<CrowdWorksCompanyName /></div>
        </FooterContent>
        <LinkToTop href="#">
          <UpArrow />
        </LinkToTop>
      </FooterWrapper>
    </Footer>
  )
}
